module.exports = __webpack_public_path__ + "img/playbutton25.3d234ba5.png";